import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

import { Store } from '@ngrx/store';
import { AppState } from '@app/store/app.state';
import {
  GlobalSelectors,
  WorkOrderSelectors,
  WorkOrderActions,
  AuthSelectors,
} from '@app/store';
import { Options } from 'angular2-csv';
import { CP_PERMISSIONS } from '@app/shared/app.constants';
import { WorkorderDetailsModalComponent } from '@app/shared/components/workorder-details-modal/workorder-details-modal.component';

@Component({
  selector: 'app-onetimeservices-list',
  templateUrl: './onetimeservices-list.component.html',
  styleUrls: ['./onetimeservices-list.component.scss'],
})
export class OnetimeservicesListComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  tablePageNumber: number = null;
  searchText = '';

  allWorkOrder: any[];
  allWorkOrdersWithProducts: any[];
  currentWorkOrder: any;
  csvReportDate = this.datePipe
    .transform(new Date(), 'MM/dd/yyyy')
    .replace('/', '_');

  statusMap = {
    'Open - Unscheduled': 'Unscheduled',
    'Open - Scheduled': 'Scheduled',
    'Open - In Progress': 'In Progress',
    'Open - Completed': 'Completed',
    'Closed - Posted': 'Completed',
    'Closed - Canceled': 'Cancelled',
  };

  csvReportOptions: Options = {
    filename: '',
    title: '',
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    headers: [
      'Site Name',
      'Request Type',
      'Work Order',
      'Confirmed Service Date',
      'Booking Status',
      'Product',
      'Equipment',
      'Quantity',
      'Unit Price',
    ],
    showTitle: false,
    useBom: false,
    removeNewLines: true,
    keys: [
      'serviceAccountName',
      'requestType',
      'workOrderNumber',
      'confirmedServiceDate',
      'systemStatus',
      'productName',
      'equipmentName',
      'quantity',
      'estimateUnitPrice',
    ],
  };

  constructor(
    private store: Store<AppState>,
    private datePipe: DatePipe,
    public modal: MatDialog
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.store
        .select(AuthSelectors.getUserPermissions)
        .pipe(
          switchMap(userPermissions =>
            this.store.select(GlobalSelectors.getSelectedGlobalFilters).pipe(
              filter(
                selectedBillingAcc =>
                  userPermissions.includes(CP_PERMISSIONS.ONETIME_READ) &&
                  selectedBillingAcc.billingAccounts.length > 0
              ),
              distinctUntilChanged((prev, curr) => {
                return JSON.stringify(prev) === JSON.stringify(curr);
              })
            )
          )
        )
        .subscribe(selectedBillingAcc => {
          this.store.dispatch(
            WorkOrderActions.getWorkOrders({ requestBody: selectedBillingAcc })
          );

          this.store.dispatch(
            WorkOrderActions.getWorkOrdersWithProducts({
              requestBody: selectedBillingAcc,
            })
          );
        })
    );
    this.setAllWorkOrder();
    this.setAllWorkOrdersWithProducts();
  }
  setAllWorkOrder() {
    this.subscriptions.add(
      this.store
        .select(WorkOrderSelectors.getAllWorkOrder)
        .pipe(
          filter(response => response !== null && response.length > 0),
          map(workOrders =>
            workOrders.map(workOrder => ({
              ...workOrder,
              confirmedServiceDate: workOrder.confirmedServiceDate
                ? this.datePipe.transform(
                    workOrder.confirmedServiceDate,
                    'MM/dd/yyyy'
                  )
                : '',
              systemStatus:
                this.statusMap[workOrder.systemStatus] ||
                workOrder.systemStatus,
            }))
          )
        )
        .subscribe(allWorkOrder => {
          this.allWorkOrder = [];
          this.allWorkOrder = allWorkOrder;
        })
    );
  }

  redirectToWorkOrderDetails($event: { workOrderId: string }) {
    const { workOrderId } = $event;

    this.store.dispatch(WorkOrderActions.currentWorkOrderStartLoading());
    this.store.dispatch(WorkOrderActions.getWorkOrderDetails({ workOrderId }));
    this.modal.open(WorkorderDetailsModalComponent, {});
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  setAllWorkOrdersWithProducts() {
    this.subscriptions.add(
      this.store
        .select(WorkOrderSelectors.getAllWorkOrderWithProducts)
        .pipe(
          filter(response => response !== null && response.length > 0),
          map(workOrders =>
            workOrders.map(workOrder => ({
              ...workOrder,
              confirmedServiceDate: workOrder.confirmedServiceDate
                ? this.datePipe.transform(
                    workOrder.confirmedServiceDate,
                    'MM/dd/yyyy'
                  )
                : '',
              systemStatus:
                this.statusMap[workOrder.systemStatus] ||
                workOrder.systemStatus,
            }))
          )
        )
        .subscribe(allWorkOrdersWithProducts => {
          this.allWorkOrdersWithProducts = [];
          this.allWorkOrdersWithProducts = allWorkOrdersWithProducts;
        })
    );
  }
}
